import {
  titleCase,
  camelCase as camel,
  pascalCase,
  snakeCase as snake,
  sentenceCase,
} from "change-case-all";

export function screamingSnake(input: string) {
  return snake(input).toUpperCase();
}

function unsnakeString(input: string) {
  return input.replace(/_/g, " ");
}

/**
 * Cases like `The Title of a Book or Film`.
 * Default {@link TitleOptions} will unsnake snake_case inputs and will NOT maintain ALL CAPS substrings.
 */
function title(input: string, options?: TitleOptions): string {
  // Must first always unsnake so capitalization works as intended
  let result: string = unsnakeString(input);
  const optionsWithDefaults = {
    unsnake: options?.unsnake === undefined ? true : options.unsnake,
    maintainAllCaps:
      options?.maintainAllCaps === undefined ? false : options.maintainAllCaps,
  };

  // The default behavior of `titleCase` is to assume you want to maintain any substring that's in ALL CAPS
  if (optionsWithDefaults.maintainAllCaps) {
    result = titleCase(result);
  } else {
    result = titleCase(result.toLowerCase());
  }

  if (optionsWithDefaults.unsnake === false) {
    // Can't use the snake method here as that lowercases everything we just Title Cased
    return result.replace(/ /g, "_");
  }
  return result;
}

type TitleOptions = {
  /**
   * Set to true and any substring in ALL CAPS in the input will be returned in ALL CAPS.
   * Many use cases in kazoo-web are for transforming ENUMS so defaults to `false`.
   *
   * @example "My NASA home page" => "My NASA Home Page"
   */
  maintainAllCaps?: boolean;
  /**
   * If input passed in in SNAKE_CASED, will return as Snake Cased. Defaults to true.
   */
  unsnake?: boolean;
};

export { sentenceCase, title, camel, pascalCase, snake };
